import React from 'react';
import { Outlet } from 'react-router-dom';
import SiteBanner from '../../components/SiteBanner';

/**
 * Customer-facing layout route.
 * Renders the site-wide banner once at the top of every customer page
 * (public + post-login) via React Router's <Outlet />, so individual
 * page files don't each need to import SiteBanner.
 *
 * Admin pages continue to use AdminLayout (and the public AdminLogin /
 * AdminForgotPassword pages each mount their own <SiteBanner scope="admin" />).
 */
export default function CustomerLayout() {
  return (
    <div className="customer-layout">
      <SiteBanner scope="customer" />
      <Outlet />
    </div>
  );
}
